import en_US from './en/en.json';
import es_ES from './es/es.json';
import es_CL from './es/CL.json';
import es_CO from './es/CO.json';
import es_EC from './es/EC.json';

const lenguajeJs = {
  global_en: { translation: en_US },
  global_es: { translation: es_ES },
  cl_es: { translation: es_CL },
  co_es: { translation: es_CO },
  ec_es: { translation: es_EC },
};

const resources = {
  'esGlobal': lenguajeJs.global_es,
  'enGlobal': lenguajeJs.global_en,
  'cl': lenguajeJs.cl_es,
  'co': lenguajeJs.co_es,
  'ec': lenguajeJs.ec_es,
  'usa': lenguajeJs.global_en
};

export default function () {
  const browserLanguage = navigator.language || 'en';
  let tld;

  if (browserLanguage.startsWith('es')) {
    tld = 'esGlobal';
  } else if (browserLanguage.startsWith('en')) {
    tld = 'enGlobal';
  } else {
    tld = 'enGlobal';
  }

  return {
    tld,
    resources
  };
}